export default __webpack_public_path__ + "static/media/bell.f396bdba.svg";